"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const updateFirstStudied_1 = __importDefault(require("../../utils/updateFirstStudied"));
function updateQuizFirstStudied(existingStats, session) {
    return (0, updateFirstStudied_1.default)(existingStats, session.timeFinished);
}
exports.default = updateQuizFirstStudied;
